import React from "react"

export const ListIcon = () => {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15.8125 2.5625C15.9062 2.5625 16 2.5 16 2.375V1.625C16 1.53125 15.9062 1.4375 15.8125 1.4375H4.1875C4.0625 1.4375 4 1.53125 4 1.625V2.375C4 2.5 4.0625 2.5625 4.1875 2.5625H15.8125ZM16 7.375V6.625C16 6.53125 15.9062 6.4375 15.8125 6.4375H4.1875C4.0625 6.4375 4 6.53125 4 6.625V7.375C4 7.5 4.0625 7.5625 4.1875 7.5625H15.8125C15.9062 7.5625 16 7.5 16 7.375ZM16 12.375V11.625C16 11.5312 15.9062 11.4375 15.8125 11.4375H4.1875C4.0625 11.4375 4 11.5312 4 11.625V12.375C4 12.5 4.0625 12.5625 4.1875 12.5625H15.8125C15.9062 12.5625 16 12.5 16 12.375ZM2.625 2.75V1.25C2.625 1.0625 2.4375 0.875 2.25 0.875H0.75C0.53125 0.875 0.375 1.0625 0.375 1.25V2.75C0.375 2.96875 0.53125 3.125 0.75 3.125H2.25C2.4375 3.125 2.625 2.96875 2.625 2.75ZM2.625 7.75V6.25C2.625 6.0625 2.4375 5.875 2.25 5.875H0.75C0.53125 5.875 0.375 6.0625 0.375 6.25V7.75C0.375 7.96875 0.53125 8.125 0.75 8.125H2.25C2.4375 8.125 2.625 7.96875 2.625 7.75ZM2.625 12.75V11.25C2.625 11.0625 2.4375 10.875 2.25 10.875H0.75C0.53125 10.875 0.375 11.0625 0.375 11.25V12.75C0.375 12.9688 0.53125 13.125 0.75 13.125H2.25C2.4375 13.125 2.625 12.9688 2.625 12.75Z" />
    </svg>
  )
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Icons/ListIcon.js